import router from './create-order.router'

export default { router }
